module.exports = __webpack_public_path__ + "static/img/icon-scanning.925b2666.svg";